function getDefaultRoute() {
  return '/ESC-Congress';
}

export { getDefaultRoute };

